export const EMPLOYEE_DICTIONARIES_TYPES = [
    { id: 1, name: 'TYPE_DEPARTMENT' },
    { id: 2, name: 'TYPE_JOB' },
    { id: 3, name: 'TYPE_ORGANIZATION' },
    { id: 4, name: 'TYPE_STATUS' },
    { id: 5, name: 'TYPE_SUBDIVISION' },
]

export const EMPLOYEES_OBJECT_ROWS = ['organization', 'department', 'city', 'subdivision', 'job']

export const USERS_STATUS_OPTIONS = [
    { id: 1, name: 'Активный' },
    { id: 2, name: 'Неактивный' },
]
